export const sheetsExtensionFaqData = [ 
// {
//     question: "Is Xero data stored?",
//     answer: "No. Xero data is used only to create draft bills and is not stored by us."
// }, 
{
    question: "Does the extension extract text or just table data?",
    answer: <span><a style={{textDecoration: 'none'}} href="https://workspace.google.com/marketplace/app/convert_pdf_to_google_sheets/687083288287" target="_blank" rel="noopener">Convert PDF to Google Sheets™</a> is specifically built to extract only tabular data. For normal text extraction, you can use our <span style={{color: 'navy', textDecoration: 'none', cursor: 'pointer'}} onClick={() => window.open('https://www.easyimagetotext.com', '_blank')}>Text OCR app</span>.</span>
}, {
    question: "What types of documents does this extension work well with?",
    answer: "Clear, structured tables (invoices, bills, receipts, reports, etc.) where data is arranged in rows and columns."
}, {
    question: "Does the extension support handwritten text?",
    answer: "Yes, but accuracy depends on handwriting clarity."
}, {
    question: "Is PDF supported?",
    answer: "Yes, PDF is supported. You can upload a PDF, select the page numbers and extract."
}, {
    question: "What image formats are supported?",
    answer: "Common image formats (JPG, PNG, BMP, GIF, WEBP, etc.)."
}, {
    question: "Is the extracted data 100% accurate?",
    answer: "No. OCR is not perfect. Accuracy depends on the quality and structure of the document. Always review and verify the data before using it for accounting or official purposes."
}, {
    question: "Does the extension store my uploaded files?",
    answer: "No. Files are processed temporarily for extraction and are not stored permanently."
}, 
// {
//     question: "Can I connect more than one Xero organisation at the same time?",
//     answer: "No. You can connect only one Xero organisation at a time. To use a different organisation, disconnect and reconnect Xero."
// }, {
//     question: "How do I switch Xero organisation?",
//     answer: "Disconnect Xero from the add-on and reconnect it. During reconnection, you can choose the required organisation."
// }, {
//     question: "What happens if my Xero connection expires or fails?",
//     answer: "If the Xero connection expires or fails, you’ll be prompted to reconnect Xero before creating draft bills."
// }, 
{
    question: "Is this extension free to use?",
    answer: <div>We offer 3 free credits every month. You can also instantly unlock 3 additional free credits by sharing the add-on with your network. For higher volumes you can upgrade to our premium plans. We offer both subscriptions and top-up plans. Check out our <span style={{color: 'navy', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => window.open('https://www.easyimagetotext.com/sheets-extension-pricing', '_blank')}>pricing page</span> to compare plans and choose what suits you best.</div>
}, {
    question: "What is a credit used for?",
    answer: "1 credit is used for 1 successful extraction of an image or 1 PDF page."
}, {
    question: "What is the difference between subscription and top-up plans?",
    answer: 'Subscription plans offer you "n" credits every month, with 30-day validity. Top-up plans offer you "n" credits one-time, with lifetime validity.'
}, {
    question: "What if I run out of credits even with a subscription?",
    answer: 'If you need more credits before your subscription renews, you can use the top-up plans to add more credits with lifetime validity.'
}, {
    question: "If I use a top-up plan, will my current subscription get cancelled?",
    answer: 'No. Top-up plans are independent of any subscription. They just add credits with lifetime validity.'
}, {
    question: "If I choose a subscription, will my current top-up balance get cancelled?",
    answer: 'No. Top-up balance has lifetime validity, and will add to the subscription balance. Both are independent.'
}, {
    question: "What is your refund policy?",
    answer: <div>We offer a 3-day refund policy only for Subscription plans. If you're not satisfied with the service, you may request a full refund within 3 days of your purchase - no questions asked. <br/>To request a refund, contact us at <b>support@easyimagetotext.com</b> <br/>One-time (top-up) plans are non-refundable.</div>
}, {
    question: "Where can I manage my subscription?",
    answer: "When you are in a subscription plan, you will see a 'Manage Subscription' button inside the extension sidebar in Google Sheets. That will take you to the corresponding portal."
}, {
    question: "What makes this extension different from other table extraction tools?",
    answer: <ul>
                <li>Works directly inside Google Sheets as a sidebar, 1-click import</li>
                <li>No data stored permanently - full privacy</li>
                <li>Preserves columns, rows and layout</li>
                <li>Reasonable pricing</li>
            </ul>
}, {
    question: "How can I contact you for queries or support?",
    answer: <span>Reach us anytime at <b>support@easyimagetotext.com</b> or you can use the chatbot in the bottom right to send a message.</span>
}]